"use client"

import { useState } from "react"
import { Box, IconButton, Typography } from "@mui/material"
import ChevronLeft from "@mui/icons-material/ChevronLeft"
import ChevronRight from "@mui/icons-material/ChevronRight"
import { format, getDaysInMonth, startOfMonth, getDay, isToday, isSameDay } from "date-fns"

export function Calendar({ selectedDate, onDateSelect }) {
  const today = new Date()
  const [currentDate, setCurrentDate] = useState(today)

  const currentMonth = currentDate.getMonth()
  const currentYear = currentDate.getFullYear()
  const monthName = format(currentDate, "MMMM yyyy")

  const daysInMonth = getDaysInMonth(currentDate)
  const firstDayOfMonth = getDay(startOfMonth(currentDate))

  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

  const goToPrevMonth = () => {
    setCurrentDate(new Date(currentYear, currentMonth - 1, 1))
  }

  const goToNextMonth = () => {
    setCurrentDate(new Date(currentYear, currentMonth + 1, 1))
  }

  const handleDateClick = (day) => {
    const date = new Date(currentYear, currentMonth, day)
    onDateSelect(date)
  }

  const isSelected = (day) => {
    return selectedDate && isSameDay(selectedDate, new Date(currentYear, currentMonth, day))
  }

  return (
    <Box sx={{ backgroundColor: "#02111B", color: "white", borderRadius: 1, p: 2, width: "100%" }}>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <IconButton onClick={goToPrevMonth} sx={{ color: "white" }}>
          <ChevronLeft />
        </IconButton>
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {monthName}
        </Typography>
        <IconButton onClick={goToNextMonth} sx={{ color: "white" }}>
          <ChevronRight />
        </IconButton>
      </Box>

      {/* Weekday headers */}
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 1, mb: 1 }}>
        {weekdays.map((day) => (
          <Typography key={day} variant="caption" sx={{ textAlign: "center", color: "#9e9e9e" }}>
            {day}
          </Typography>
        ))}
      </Box>

      {/* Calendar grid */}
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 1 }}>
        {/* Empty cells for days before the first of the month */}
        {Array.from({ length: firstDayOfMonth }).map((_, index) => (
          <Box key={`empty-${index}`} sx={{ height: 36 }} />
        ))}

        {/* Days of the month */}
        {Array.from({ length: daysInMonth }).map((_, index) => {
          const day = index + 1
          const date = new Date(currentYear, currentMonth, day)
          const today = isToday(date)
          const selected = isSelected(day)

          return (
            <Box
              key={`day-${day}`}
              onClick={() => handleDateClick(day)}
              sx={{
                height: 36,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                cursor: "pointer",
                backgroundColor: selected ? "white" : "transparent",
                color: selected ? "#02111B" : "white",
                border: today ? "1px solid #FFC857" : "none",
                "&:hover": {
                  backgroundColor: selected ? "white" : "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <Typography variant="body2">{day}</Typography>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}